module.exports = __webpack_public_path__ + "img/tank-vertical-disabled.08788418.svg";